import { useLayoutEffect, useRef } from 'react';

export default function useFocusOnMountRef(focusOnMount: boolean = true) {
  const titleRef = useRef<HTMLLegendElement>(null);

  useLayoutEffect(() => {
    if (focusOnMount && titleRef.current) {
      titleRef.current.focus();
    }
  }, [focusOnMount]);

  return titleRef;
}
